export const isProduction = import.meta.env.MODE === 'production';
export const isTest = import.meta.env.MODE === 'testing';
